import { useState } from 'react';
import UserCustomerTextArea from '../../InputFields/UserCustomerTextArea';

const UploadFileDataType = ({
  onDataChange,
  helpText,
}: {
  onDataChange: (data: any) => void;
  helpText: string;
}) => {
  const [formData, setFormData] = useState({
    helpText: helpText || '',
  });

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    const updatedFormData = { ...formData, [name]: value };

    setFormData(updatedFormData);
    onDataChange(updatedFormData);
  };

  return (
    <div className="ml-4">
      <UserCustomerTextArea
        label="Help Text"
        name="helpText"
        value={formData.helpText}
        onChange={handleInputChange}
        placeholder="Enter the description. i.e - This section provides key points of contact for communication and support."
        description="This will help in guiding the person filling this field."
        maxLength={10000}
        rows={14}
      />
    </div>
  );
};

export default UploadFileDataType;
